const styles = (theme) => ({
  button: {
    fontSize: 14,
    padding: theme.spacing(0.5, 1, 0.5, 0),
    minWidth: 'auto',
    '& .MuiButton-label': {
      whiteSpace: 'nowrap',
    },
  },
});

export default styles;
